export interface EmptyProps {
    messageText: string,
    buttonText?: string,
    handleButtonClick?: () => void
}

export const InitialEmptyProps: EmptyProps = {
    messageText: ""
}